import { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, useSpring } from "framer-motion";

export const Counter = ({ to = 0, duration = 1.6, className = "", testId }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-20% 0px" });
    const [display, setDisplay] = useState(0);
    const mv = useMotionValue(0);
    const spring = useSpring(mv, { stiffness: 60, damping: 18, mass: 1 });

    useEffect(() => {
        if (inView) {
            mv.set(to);
        }
    }, [inView, to, mv]);

    useEffect(() => {
        const unsubscribe = spring.on("change", (latest) => {
            setDisplay(Math.round(latest));
        });
        return () => unsubscribe();
    }, [spring]);

    return (
        <span ref={ref} className={className} data-testid={testId}>
            {display}
        </span>
    );
};

export default Counter;
